<div class="container-fluid">
    <div class="row">
        <div class="col-lg-8 offset-lg-2">
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <a class="navbar-brand" routerLink="/home">
                    <div class="fs-logo-container">
                        <img src="assets/images/FILPARTY-ICON.png" alt="">&nbsp;
                        <span>Filparty Explorer</span>
                    </div>
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <img src="assets/images/menu.png" alt="">
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item active">
                            <a class="nav-link" routerLink="/home">Home</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="https://filparty.com/#how_it_work" target="_blank">Features</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="https://filparty.com/#about" target="_blank">About</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="https://filparty.com/#team" target="_blank">Our Team</a>
                        </li>
                    </ul>
                    <form class="form-inline my-2 my-lg-0">
                        <button class="btn btn-outline-success my-2 my-sm-0" (click)="onSubmit()">Donate</button>
                    </form>
                </div>
            </nav>
        </div>
    </div>
</div>

